export const HOME_MATCH_SWITCH_CONTENT = {
    TEXT: `Oszczędź czas na przeglądaniu setek ogłoszeń. Dzięki tej opcji automatycznie wysyłamy zapytania w Twoim imieniu do deweloperów, którzy budują to, czego szukasz. Pozwól, by to oni sami zgłaszali się do Ciebie z pasującymi ofertami.
O najlepszych okazjach poinformujemy Cię SMS-em i e-mailem.`,
    TITLE: "Usługa: Dopasujemy oferty dla Ciebie"
} as const;

export const HOME_MATCH_SERVICE_NOTIFICATION_CONTENT = {
    DISABLED: "Usługa automatycznych zapytań Homematch została wyłączona",
    ENABLED: "Usługa automatycznych zapytań Homematch została włączona"
} as const;

export const CONSENT_REVOKE_MODAL_CONTENT = {
    DESCRIPTION: "Czy na pewno nie chcesz otrzymywać informacji o nowych ofertach nieruchomości i promocjach deweloperskich przez"
} as const;

export const PHONE_NUMBER_FORM_CONTENT = {
    GENERIC_ERROR: "Coś poszło nie tak, spróbuj ponownie",
    INVALID_FORMAT: "Podaj poprawny numer telefonu",
    LABEL: "Numer telefonu",
    LENGTH_ERROR: "Numer telefonu musi mieć 9 cyfr"
} as const;

export const USER_DATA_VERIFICATION_MODAL_CONTENT = {
    CONFIRMATION_SENT: {
        EMAIL: "Na Twój adres e-mail wysłaliśmy wiadomość z linkiem do potwierdzenia Twoich danych",
        PHONE: "Na Twój numer telefonu wysłaliśmy wiadomość z linkiem do potwierdzenia Twoich danych"
    },
    EMAIL_LABEL: "E-mail:",
    INSTRUCTION: {
        EMAIL: "Zaloguj się do poczty i kliknij w link, aby dokończyć weryfikację Twojego adresu e-mail",
        PHONE: "Sprawdź wiadomość SMS i kliknij w link, aby dokończyć weryfikację Twojego numeru telefonu"
    },
    PHONE_LABEL: "Telefon:",
    TITLE: "Twoje dane"
} as const;
export const HOME_MATCH_SWITCH_CONTENT = {
    TEXT: `Oszczędź czas na przeglądaniu setek ogłoszeń. Dzięki tej opcji automatycznie wysyłamy zapytania w Twoim imieniu do deweloperów, którzy budują to, czego szukasz. Pozwól, by to oni sami zgłaszali się do Ciebie z pasującymi ofertami.
O najlepszych okazjach poinformujemy Cię SMS-em i e-mailem.`,
    TITLE: "Usługa: Dopasujemy oferty dla Ciebie"
} as const;

export const HOME_MATCH_SERVICE_NOTIFICATION_CONTENT = {
    DISABLED: "Usługa automatycznych zapytań Homematch została wyłączona",
    ENABLED: "Usługa automatycznych zapytań Homematch została włączona"
} as const;

export const CONSENT_REVOKE_MODAL_CONTENT = {
    DESCRIPTION: "Czy na pewno nie chcesz otrzymywać informacji o nowych ofertach nieruchomości i promocjach deweloperskich przez"
} as const;

export const PHONE_NUMBER_FORM_CONTENT = {
    GENERIC_ERROR: "Coś poszło nie tak, spróbuj ponownie",
    INVALID_FORMAT: "Podaj poprawny numer telefonu",
    LABEL: "Numer telefonu",
    LENGTH_ERROR: "Numer telefonu musi mieć 9 cyfr"
} as const;

export const USER_DATA_VERIFICATION_MODAL_CONTENT = {
    CONFIRMATION_SENT: {
        EMAIL: "Na Twój adres e-mail wysłaliśmy wiadomość z linkiem do potwierdzenia Twoich danych",
        PHONE: "Na Twój numer telefonu wysłaliśmy wiadomość z linkiem do potwierdzenia Twoich danych"
    },
    EMAIL_LABEL: "E-mail:",
    INSTRUCTION: {
        EMAIL: "Zaloguj się do poczty i kliknij w link, aby dokończyć weryfikację Twojego adresu e-mail",
        PHONE: "Sprawdź wiadomość SMS i kliknij w link, aby dokończyć weryfikację Twojego numeru telefonu"
    },
    PHONE_LABEL: "Telefon:",
    TITLE: "Twoje dane"
} as const;
